import { Link, useParams } from "react-router-dom";
import Footer from "../components/Footer.tsx";
import UserImage from "../components/user/core/UserImage";
import UserTitle from "../components/user/core/UserTitle";
import UserDescription from "../components/user/core/UserDescription";
import { ROUTE_EDIT_PROFILE } from "../const/routes";
import PopUp, { openModal } from "../components/core/PopUp";
import ReportPost from "../components/report/ReportPost";
import { SubmitProvider } from "../context/context.submit";
import { IconAlertCircle, IconReport } from "@tabler/icons-react";
import CurrentUser from "../components/core/auth/CurrentUser";
import SEO from "../components/core/SEO.tsx";

function UserPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>User not found...</div>;
  }

  return (
    <div className="safe-top-with-hanger safe-bottom-with-dock">
      <SEO title="Profil" noIndex />
      <PopUp
        id="report-user"
        title={
          <>
            <IconReport /> Melden?
          </>
        }
      >
        <SubmitProvider
          iButtonElem={
            <>
              <IconAlertCircle />
              Melden
            </>
          }
        >
          <ReportPost userId={id} />
        </SubmitProvider>
      </PopUp>
      <main className="flex flex-col items-center min-h-screen justify-center">
        <div className="card bg-base-100 shadow-2xl w-full max-w-4xl">
          <div className="card-body items-center text-center space-y-6">
            <UserImage
              userId={id}
              sizes="128px"
              className="w-40 h-40 rounded-full object-cover border-4 border-base-300 shadow"
            />
            <h1 className="card-title text-2xl font-bold text-base-content">
              <UserTitle userId={id} />
            </h1>
            <p className="text-base-content">
              <UserDescription userId={id} />
            </p>

            <div className="divider"></div>
            <div className="card-actions justify-center flex-wrap gap-4">
              <CurrentUser>
                {(userId) =>
                  userId !== id && (
                    <button
                      onClick={() => openModal("report-user")}
                      className="btn btn-secondary"
                    >
                      Melden
                    </button>
                  )
                }
              </CurrentUser>
              <CurrentUser>
                {(userId) =>
                  userId === id && (
                    <Link to={ROUTE_EDIT_PROFILE} className="btn btn-accent">
                      Bearbeiten
                    </Link>
                  )
                }
              </CurrentUser>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default UserPage;
